/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { RxDashboard } from "react-icons/rx";
import { IoSettingsOutline, IoClose, IoLogOutOutline } from "react-icons/io5";
import { FaUserLock } from "react-icons/fa";
import { BiStopwatch, BiSupport } from "react-icons/bi";
import { MdOutlineStackedBarChart } from "react-icons/md";
import { LiaUsersSolid } from "react-icons/lia";
import { GrTransaction, GrUserExpert } from "react-icons/gr";
import { logoutFunction } from "../../_helpers";

const menuItems = [
  {
    label: "Dashboard",
    icon: <RxDashboard size={18} />,
    path: "/app/dashboard",
  },
  {
    label: "User Management",
    icon: <LiaUsersSolid size={18} />,
    path: "/app/user-management",
  },
  { label: "Contact Us", icon: <BiSupport size={18} />, path: "/app/contact" },
  // {
  //   label: 'FAQs Management',
  //   icon: <TbCategoryPlus size={18} />,
  //   path: '/app/faq-management'
  // },
  // {
  //   label: 'Coming Soon Mng.',
  //   icon: <MdDownloading size={18} />,
  //   path: '/app/coming-soon'
  // },
  // {
  //   label: 'Coin Features Mng.',
  //   icon: <MdDownloading size={18} />,
  //   path: '/app/coin-features'
  // },
  // {
  //   label: 'Road Map Mng.',
  //   icon: <RiRoadMapFill size={18} />,
  //   path: '/app/roadmap'
  // },
  {
    label: 'Expert Opinion Mng.',
    icon: <GrUserExpert size={18} />,
    path: '/app/expert-opinion'
  },
  {
    label: "App Settings",
    icon: <IoSettingsOutline size={18} />,
    path: "/app/app-setting",
  },
  {
    label: "ICO management",
    icon: <MdOutlineStackedBarChart size={18} />,
    path: "/app/ico-management",
  },
  {
    label: "Investment History",
    icon: <GrTransaction size={18} />,
    path: "/app/investment-history",
  },
  {
    label: "Term and Policy",
    icon: <GrTransaction size={18} />,
    path: "/app/term-policy",
  },
  {
    label: "Login History",
    icon: <BiStopwatch size={18} />,
    path: "/app/login-history",
  },
  {
    label: "Change Password",
    icon: <FaUserLock size={18} />,
    path: "/app/change-password",
  },
  {
    label: "Logout",
    icon: <IoLogOutOutline size={18} />,
    path: "",
    callback: () => logoutFunction(),
  },
];

function Sidebar({ navbarOpen, setNavbarOpen }) {
  const location = useLocation();
  const navigate = useNavigate();

  const onClickMenu = (url) => {
    navigate(url);
    if (window.innerWidth <= 768) setNavbarOpen(false);
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 1024) {
        setNavbarOpen(true); // Optional: auto-open on desktop
      }else{
        setNavbarOpen(false); // Optional: auto-close on mobile
      }
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      {/* Show the menu button when sidebar is hidden */}
      {/* {!navbarOpen && (
        <button
          className='fixed top-4 left-4 z-50 bg-[#07071C] px-3 py-2 rounded-md text-white'
          onClick={() => setNavbarOpen(true)}
        >
          ☰
        </button>
      )} */}

      <div
        className={`fixed left-0 inset-y-0 w-64 z-40 flex-col bg-[#07071C] transition-all duration-300 border-r border-[#37404a] ${
          navbarOpen ? "flex" : "hidden"
        }`}
      >
        <div className="flex flex-col flex-1 w-64 h-full">
          {/* Sidebar Header */}
          <div className="flex items-center justify-between px-4 py-2 border-b border-[#37404a]">
            <div className="flex items-center gap-2">
              <img src="/Img/vunecoin-logo.png" alt="logo" className="" />
              <h1 className="lg:text-3xl text-xl font-bold text-white">
                VCNC ICO
              </h1>
            </div>
            <button
              className="lg:hidden text-[#07071C] bg-white rounded-full "
              onClick={() => setNavbarOpen(false)}
            >
              <IoClose size={30} />
            </button>
          </div>

          {/* Navigation Menu */}
          <nav className="flex flex-col w-full px-4 pt-4 space-y-2">
            {menuItems.map(({ label, icon, path, callback }) => (
              <span
                key={path}
                onClick={() => {
                  if (callback) {
                    callback();
                  } else if (path) {
                    onClickMenu(path);
                  }
                }}
                className={`cursor-pointer flex items-center space-x-4 px-4 py-2 text-sm transition duration-150 rounded-md ${
                  location.pathname === path
                    ? "text-white bg-[#37404a]"
                    : "text-white hover:bg-[#37404a]/50 hover:text-white"
                }`}
              >
                {icon}
                <span className="text-base">{label}</span>
              </span>
            ))}
          </nav>
        </div>
      </div>
    </>
  );
}

export default Sidebar;
